import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=dadb8412&scoped=true&"
import script from "./companies.vue?vue&type=script&lang=ts&"
export * from "./companies.vue?vue&type=script&lang=ts&"
import style1 from "./companies.vue?vue&type=style&index=1&id=dadb8412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadb8412",
  null
  
)

export default component.exports